import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BulkDeleteResponse, PlannerApi, RevertResponse, ScheduleVersion} from '@api/planner';

@Injectable({providedIn: 'root'})
export class ScheduleVersionEndpoint {

  constructor(private api: PlannerApi) {}

  getAll(scheduleId: number): Observable<ScheduleVersion[]> {
    return this.api.get(`/schedules/${scheduleId}/versions`);
  }

  update(versionId: number, data: Partial<ScheduleVersion>): Observable<ScheduleVersion> {
    return this.api.put(`/scheduleversion/${versionId}`, data);
  }

  revert(scheduleId: number, versionId: number): Observable<RevertResponse> {
    return this.api.post(`/schedules/${scheduleId}/versions/${versionId}/revert`);
  }

  delete(versionId: number): Observable<void> {
    return this.api.delete(`/scheduleversion/${versionId}`);
  }

  bulkDelete(scheduleId: number, ids: number[]): Observable<BulkDeleteResponse> {
    return this.api.deleteWithBody(`/schedules/${scheduleId}/versions`, {ids});
  }
}
